import React, {useMemo, useState} from 'react';
import {NavLink, useLocation, useNavigate} from 'react-router-dom';
import classNames from 'classnames';
import {useAppDispatch, useAppSelector} from '../../hooks';
import {logout} from '../../store/app.slice';
import {Menu} from '../../icons';
import {colors} from '../../utils/constants';
import {SUBSCRIPTION_ROOT_PATH} from '../../pages/Subscription/subscriptionPaths';
import {useGetUserProfileQuery} from '../../pages/Profile/Profile.api';
import styles from './Sidebar.module.scss';
import {getSidebarConfig} from './config';

export const Sidebar = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const {token} = useAppSelector(state => state.app);
    const {data: profile} = useGetUserProfileQuery({token}, {skip: !token});
    const sidebarItems = useMemo(
        () => getSidebarConfig(profile?.is_company_owner),
        [profile?.is_company_owner],
    );

    const handleLogout = () => {
        dispatch(logout({navigate}));
        navigate('/');
    };

    return (
        <>
            <div className={styles.sidebarMobile}>
                 <div className={styles.sidebarMobile__title}>Профиль</div>
                <Menu
                    width={40}
                    height={40}
                    color={colors.grey200}
                    style={{cursor: 'pointer'}}
                    onClick={() => setShowMenu(!showMenu)}
                />
            </div>
            <ul className={showMenu ? classNames(styles.sidebarList, styles.sidebarListShow) : styles.sidebarList}>
                {sidebarItems.map(i => {
                    if (i.path === 'exit') {
                        return (
                            <button
                                key={i.path}
                                className={classNames(styles.sidebarList__item, styles.sidebarList__itemLogout)}
                                onClick={handleLogout}>
                                {i.label}
                            </button>);
                    }
                    const subscriptionSection =
                        i.path === SUBSCRIPTION_ROOT_PATH && location.pathname.startsWith(SUBSCRIPTION_ROOT_PATH);
                    const active = subscriptionSection || location.pathname === i.path;

                    return (
                        <NavLink
                            key={i.path}
                            to={i.path}
                            className={
                                active
                                    ? classNames(styles.sidebarList__itemActive, styles.sidebarList__item)
                                    : classNames(styles.sidebarList__item)}
                        >{i.label}</NavLink>);
                })}
            </ul>
        </>
    );
};

